import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Shell } from "@/components/Shell";
import LoginView from "@/views/LoginView";
import UnauthorizedView from "@/views/UnauthorizedView";
import OverviewView from "@/views/OverviewView";
import ReportsView from "@/views/ReportsView";
import UsersView from "@/views/UsersView";
import VerificationsView from "@/views/VerificationsView";
import LiveView from "@/views/LiveView";
import AuditView from "@/views/AuditView";
import MapView from "@/views/MapView";
import TakedownsView from "@/views/TakedownsView";
import FeedView from "@/views/FeedView";
import PresenceView from "@/views/PresenceView";
import EarningsView from "@/views/EarningsView";
import EarningsDetailView from "@/views/EarningsDetailView";

function AppRoutes() {
  const { status, user } = useAuth();

  if (status === "loading") {
    return (
      <main className="center-screen" data-testid="auth-loading-state">
        <div className="radar-loader" aria-label="Checking secure session" />
        <p>Validating secure session…</p>
      </main>
    );
  }

  if (status === "signed-out") return <LoginView />;
  if (status === "unauthorized") return <UnauthorizedView />;

  return (
    <Shell user={user}>
      <Routes>
        <Route path="/overview" element={<OverviewView />} />
        <Route path="/reports" element={<ReportsView />} />
        <Route path="/feed" element={<FeedView />} />
        <Route path="/presence" element={<PresenceView />} />
        <Route path="/earnings" element={<EarningsView />} />
        <Route path="/earnings/:userId" element={<EarningsDetailView />} />
        <Route path="/takedowns" element={<TakedownsView />} />
        <Route path="/users" element={<UsersView />} />
        <Route path="/verifications" element={<VerificationsView />} />
        <Route path="/live" element={<LiveView />} />
        <Route path="/map" element={<MapView />} />
        <Route path="/audit" element={<AuditView />} />
        <Route path="*" element={<Navigate to="/overview" replace />} />
      </Routes>
    </Shell>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster theme="dark" richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}